import { Box } from '@mui/material';
import styled from 'styled-components';
export const BoxHeaderContainer = styled(Box) `
  display: flex;
  padding: 1rem;
  margin: 0;
  box-sizing: border-box;
`;
export default BoxHeaderContainer;
